__turbopack_context__.v({
  "arrow": "ZGMLDW_arrow",
  "authorIcon": "ZGMLDW_authorIcon",
  "bookCardContainer": "ZGMLDW_bookCardContainer",
  "bookCount": "ZGMLDW_bookCount",
  "center": "ZGMLDW_center",
  "contibutorDesc": "ZGMLDW_contibutorDesc",
  "contibutorHeading": "ZGMLDW_contibutorHeading",
  "contibutorImage": "ZGMLDW_contibutorImage",
  "contributorDetail": "ZGMLDW_contributorDetail",
  "contributorSection": "ZGMLDW_contributorSection",
  "relatedPost": "ZGMLDW_relatedPost",
  "relatedPostSection": "ZGMLDW_relatedPostSection",
  "topPadding": "ZGMLDW_topPadding",
});
